var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import { apiCreateClientRfpShareDocumentMessageLog, apiGetListClientRfpShareDocumentOneViewRequest, } from '@/actions/ClientRfpShareDocumentActions';
import { usePromiseDoingCallback } from '@/hooks/async/loading/usePromiseDoingCallback';
import { setRfpCliFileMessageReadAction } from '@/pages/rfp/client/RfpClientOneFileOne/RfpClientOneFileOneMessageReducer';
import { resetRfpCliFileViewRequestCountAction, updateRfpCliFileViewRequestDataAction, } from '@/pages/rfp/client/RfpClientOneFileOne/RfpClientOneFileOneViewRequestReducer';
import { wrapDispatch } from '@/utils/actions/dispatch';
/**
 * 閲覧申請一覧：データの取得, ローディング制御
 */
export const useRfpClientOneFileOneFetchViewRequest = (args) => {
    const { dispatch, id, messageDispatch, unmountRef, viewRequestDispatch, viewRequestId, } = args;
    /**
     * 閲覧申請一覧（メニュー表示用）の取得を行う
     */
    const baseFetchViewRequest = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        const { payload } = yield wrapDispatch(dispatch, apiGetListClientRfpShareDocumentOneViewRequest({ path: { id } }, {}));
        // レスポンスをコンポーネントに合わせて整形する
        const values = payload.list.map((item) => ({
            companyName: item.organization_name,
            hasUnAnswer: item.status === 'received',
            id: item.id,
            unReadCount: item.unread_count,
        }));
        // stateに反映
        viewRequestDispatch(updateRfpCliFileViewRequestDataAction(values));
    }), [dispatch, id, viewRequestDispatch]);
    const { callbackPromiseEvent: fetchViewRequest, doing: loadingOfViewRequest, } = usePromiseDoingCallback({
        promiseEvent: baseFetchViewRequest,
        unmountRef,
    });
    /**
     * 最終メッセージ表示イベント：閲覧申請一覧から、指定IDの既読カウントを0にする
     */
    const displayLastMessage = useCallback((options) => {
        // 既読APIを実行
        dispatch(apiCreateClientRfpShareDocumentMessageLog({
            path: {
                id,
                share_document_message_id: options.messageId,
                view_request_id: viewRequestId,
            },
        }, {}));
        // メニュー内の未読系の値を既読状態にする
        viewRequestDispatch(resetRfpCliFileViewRequestCountAction(viewRequestId));
        // 各メッセージを既読状態にする
        messageDispatch(setRfpCliFileMessageReadAction(viewRequestId));
    }, [dispatch, id, messageDispatch, viewRequestDispatch, viewRequestId]);
    return {
        displayLastMessage,
        fetchViewRequest,
        loadingOfViewRequest,
    };
};
